<template>
  <div class="date-time-interval d-flex flex-column">
    <el-tooltip :content="fromPlaceholder" placement="top" effect="light" :open-delay="300" transition="el-zoom-in-top">
      <el-date-picker
        v-model="from"
        :data-id="`${name}-from`"
        clearable
        :type="getComponentType"
        :placeholder="fromPlaceholder"
        :picker-options="pickerOptions"
        :format="getDateFormat"
        :value-format="valueFormat"
        @change="onChange($event, 'from')"
      >
      </el-date-picker>
    </el-tooltip>
    <el-tooltip
      :content="toPlaceholder"
      placement="bottom"
      effect="light"
      :open-delay="300"
      transition="el-zoom-in-top"
    >
      <el-date-picker
        v-model="to"
        :data-id="`${name}-to`"
        clearable
        :type="getComponentType"
        :placeholder="toPlaceholder"
        :picker-options="pickerOptions"
        :format="getDateFormat"
        :value-format="valueFormat"
        @change="onChange($event, 'to')"
      >
      </el-date-picker>
    </el-tooltip>
  </div>
</template>

<script>
import intervalMixin from './mixin-interval'

const TIME_FORMATS = ['time', 'time_interval', 'datetime', 'datetime_interval', 'datetime-local']
const DATE_FORMATS = ['date', 'date_interval', 'datetime', 'datetime_interval']

export default {
  name: 'FilterDateTime',
  mixins: [intervalMixin],
  data() {
    return {
      valueFormat: 'yyyy-MM-ddTHH:mm',
      from: '',
      to: '',
      fromPlaceholder: this.$i18n.t('date_time_interval_start'),
      toPlaceholder: this.$i18n.t('date_time_interval_end'),
    }
  },
  computed: {
    getComponentType() {
      return this.needTime ? 'datetime' : 'date'
    },
    getDateFormat() {
      let format = ''
      switch (this.$CORE.language.code) {
        case 'en-US': {
          format = 'MM/dd/yyyy'
          break
        }
        case 'hu-HU':
        case 'de-DE': {
          format = 'yyyy-MM-dd'
          break
        }
        default: {
          format = 'yyyy-MM-dd'
          break
        }
      }
      if (this.needTime) {
        format += ` ${this.getTimeFormat}`
      }
      return format
    },
    getTimeFormat() {
      let format = 'HH:mm'
      if (this.$CORE.language.code === 'en-US') {
        format = 'hh:mm A'
      }
      return format
    },
    needTime() {
      return TIME_FORMATS.includes(this.type)
    },
    pickerOptions() {
      return {
        firstDayOfWeek: this.$CORE.language.code === 'en-US' ? 7 : 1,
      }
    },
  },
}
</script>
